module.exports = __webpack_public_path__ + "static/img/desktop-xmgl.39c3d105.png";